export default __webpack_public_path__ + "static/CentraNo2-Bold-f88fa8d7171cfa6929f2673eff583a59.woff2";